export class EventBus {
    constructor() {
        this.eventRegistry = {};
    }
    fireEvent(eventName, ...args) {
        var _a, _b;
        if (this.eventRegistry[eventName] === undefined) {
            return;
        }
        (_a = this.eventRegistry[eventName]) === null || _a === void 0 ? void 0 : _a.forEach(x => {
            x.method.apply(null, args);
        });
        (_b = this.eventRegistry[eventName]) === null || _b === void 0 ? void 0 : _b.forEach((x, i) => {
            var _a;
            if (x.singleUse) {
                (_a = this.eventRegistry[eventName]) === null || _a === void 0 ? void 0 : _a.splice(i, 1);
            }
        });
    }
    listen(event, fn) {
        if (event instanceof Array) {
            event.forEach(eventName => this.listen(eventName, fn));
        }
        else {
            if (this.eventRegistry[event] === undefined) {
                this.eventRegistry[event] = [{ method: fn, singleUse: false }];
            }
            else if (this.eventRegistry[event].indexOf({ method: fn, singleUse: false }) === -1) {
                this.eventRegistry[event].push({ method: fn, singleUse: false });
            }
        }
    }
    wait(event, fn) {
        if (event instanceof Array) {
            event.forEach(eventName => this.wait(eventName, fn));
        }
        else {
            if (this.eventRegistry[event] === undefined) {
                this.eventRegistry[event] = [{ method: fn, singleUse: true }];
            }
            else if (this.eventRegistry[event].indexOf({ method: fn, singleUse: true }) === -1) {
                this.eventRegistry[event].push({ method: fn, singleUse: true });
            }
        }
    }
    unsubscribe(eventName, fn) {
        var _a;
        (_a = this.eventRegistry[eventName]) === null || _a === void 0 ? void 0 : _a.forEach((x, i) => {
            var _a;
            if (x.method === fn) {
                (_a = this.eventRegistry[eventName]) === null || _a === void 0 ? void 0 : _a.splice(i, 1);
            }
        });
    }
}
